import * as React from 'react';
import clsx from 'clsx';
import { useCaseSteps } from '@/hooks/queries/useCaseSteps';
import { CaseProgressSectionProps } from '@/interfaces';
import {
	getCaseProgressSteps,
	isCaseTimelineDisabled,
} from '@/utils/caseStatus';
import { Earned } from '../Earned';
import { CaseProgressStepper } from './CaseProgressStepper';

export const CaseProgressSection: React.FC<CaseProgressSectionProps> = ({
	caseApplications,
	clientApproveStatus,
	className,
}) => {
	const { data: steps } = useCaseSteps(caseApplications?.id);

	const currentStepIndex = caseApplications?.numerical_order;
	const stepItems =
		steps && currentStepIndex !== undefined
			? getCaseProgressSteps(steps.data, currentStepIndex)
			: [];

	const showEarned =
		!!caseApplications?.earned &&
		caseApplications.earned > 0 &&
		caseApplications.progress_status === 'Resolved Case';

	if (!caseApplications || stepItems.length === 0) return null;

	return (
		<div
			className={clsx(
				'border-t border-grey-100 px-[18px] pb-[22px] pt-6 lg:px-7 lg:py-6',
				className
			)}
		>
			{showEarned && (
				<div className="mb-4 flex justify-end">
					<Earned earned={caseApplications.earned} />
				</div>
			)}
			<CaseProgressStepper
				steps={stepItems}
				disabled={
					!!isCaseTimelineDisabled(caseApplications, clientApproveStatus)
				}
			/>
		</div>
	);
};
